import { createSlice } from '@reduxjs/toolkit';
import { getConferenceState } from '../base/conference/functions';
import { getParticipantById, isParticipantModerator } from '../base/participants/functions';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { isBannedRecording, isEnableBanAllRecording } from './functions';
// Action to approve a participant's ability to record
export const approveParticipantRecording = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (participant) {
        const isBanned = isBannedRecording(participant, state);
        if (isBanned) {
            conference?.recordingModerationApprove(id);
        }
    }
};
// Action to reject a participant's ability to record
export const rejectParticipantRecording = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (participant) {
        const isBanned = isBannedRecording(participant, state);
        const isModerator = isParticipantModerator(participant);
        if (!isBanned && !isModerator) {
            conference?.recordingModerationReject(id);
        }
    }
};
// Action to enable ban for all participants from recording
export const enableBanAllRecording = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllRecording(state);
    if (!isBanAll) {
        conference?.enableRecordingModeration();
    }
};
// Action to disable ban for all participants from recording
export const disableBanAllRecording = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllRecording(state);
    if (isBanAll) {
        conference?.disableRecordingModeration();
    }
};
// Initial state for the recording moderation feature
const initialState = {
    enabled: false,
    whitelist: {},
    blacklist: {},
    canRecording: undefined,
    actor: null,
};
// Slice for recording moderation
const recordingModeration = createSlice({
    name: 'features/recording-moderation',
    initialState,
    reducers: {
        disableRecordingModeration: (state, action) => {
            if (state.enabled) {
                state.enabled = false;
                state.actor = action.payload;
                state.canRecording = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        enableRecordingModeration: (state, action) => {
            if (!state.enabled) {
                state.enabled = true;
                state.actor = action.payload;
                state.canRecording = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        localParticipantApproved: (state) => {
            state.canRecording = true;
        },
        localParticipantRejected: (state) => {
            state.canRecording = false;
        },
        participantApproved: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: true
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: false
                };
            }
        },
        participantRejected: (state, action) => {
            if (state.enabled) {
                state.whitelist = {
                    ...state.whitelist,
                    [action.payload.jid]: false
                };
            }
            else {
                state.blacklist = {
                    ...state.blacklist,
                    [action.payload.jid]: true
                };
            }
        }
    }
});
ReducerRegistry.register('features/recording-moderation', recordingModeration.reducer);
export const { disableRecordingModeration, enableRecordingModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } = recordingModeration.actions;
export default recordingModeration.reducer;
